import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import translate from '../../../../commonComponents/translate';
import DateRange from '../../../../commonComponents/forms/inputs/DateRange';
import ConfigsContext from '../../../../contextProviders/ConfigsContext';
import { getStartDateAndEndDateInterval } from '../../../../services/dateUtilityFunctions';

const MonthlySummary = props => {
  const { t, data, filters, onDateChange } = props;

  const { myVA, VALeft, VARight, groupVA, personalVA } = data;

  const { startDate, endDate } = filters;

  const { organization } = useContext(ConfigsContext);
  const { directSelling } = organization;

  // Month presets in the plan timezone (BRAVON-6325); no-op for UTC plans.
  const dateRanges = {
    [t('dateRange_thisMonth')]: getStartDateAndEndDateInterval(directSelling),
    [t('dateRange_lastMonth')]: getStartDateAndEndDateInterval(
      directSelling,
      moment().subtract(1, 'months'),
    ),
    [t('dateRange_twoMonthsAgo')]: getStartDateAndEndDateInterval(
      directSelling,
      moment().subtract(2, 'months'),
    ),
    [t('dateRange_threeMonthsAgo')]: getStartDateAndEndDateInterval(
      directSelling,
      moment().subtract(3, 'months'),
    ),
    [t('dateRange_fourMonthsAgo')]: getStartDateAndEndDateInterval(
      directSelling,
      moment().subtract(4, 'months'),
    ),
  };

  return (
    <div className="monthly-summaries">
      <div className="summary-header">
        <div className="career-section-title">
          {t('report.neofin.monthlySummary')}
        </div>
        <div>
          <DateRange
            directSellingSettings={directSelling}
            id="dateRange"
            placeholder={t('report.arcova.searchDate')}
            startDate={startDate}
            endDate={endDate}
            onChange={({ startDate: sDate, endDate: eDate }) =>
              onDateChange(sDate, eDate)
            }
            onClear={() => onDateChange(null, null)}
            customRanges={dateRanges}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6 col-sm-3 summary">
          <div className="card">
            <span className="monthly-summary-label orange">
              {t('report.neofin.myVA')}
            </span>
            <span className="value">{myVA.toFixed(2)}</span>
          </div>
        </div>
        <div className="col-6 col-sm-2 summary">
          <div className="card">
            <span className="monthly-summary-label cyan">
              {t('report.neofin.VALeft')}
            </span>
            <span className="value">{VALeft.toFixed(2)}</span>
          </div>
        </div>
        <div className="col-6 col-sm-2 summary">
          <div className="card">
            <span className="monthly-summary-label blue">
              {t('report.neofin.VARight')}
            </span>
            <span className="value">{VARight.toFixed(2)}</span>
          </div>
        </div>
        <div className="col-6 col-sm-2 summary">
          <div className="card">
            <span className="monthly-summary-label yellow">
              {t('report.neofin.personalVA')}
            </span>
            <span className="value">{personalVA.toFixed(2)}</span>
          </div>
        </div>

        <div className="col-6 col-sm-3 summary">
          <div className="card">
            <span className="monthly-summary-label purple">
              {t('report.neofin.groupVA')}
            </span>
            <span className="value">{groupVA.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

MonthlySummary.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    myVA: PropTypes.number,
    VALeft: PropTypes.number,
    VARight: PropTypes.number,
    personalVA: PropTypes.number,
    groupVA: PropTypes.number,
  }).isRequired,
  onDateChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    user: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
  }).isRequired,
};

export default translate(MonthlySummary);
